const DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}/;

export const getComparableDateKey = (value) => {
  if (!value) return '';
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const candidate = String(value);
  if (DATE_KEY_PATTERN.test(candidate)) return candidate.slice(0, 10);
  const parsed = new Date(candidate);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toISOString().slice(0, 10);
};

export const getEffectiveMinimumDateKey = (
  minDate,
  today = new Date(),
  allowPastDates = false,
) => {
  const todayKey = getComparableDateKey(today);
  const requestedMinimumKey = getComparableDateKey(minDate);
  if (allowPastDates) return requestedMinimumKey;
  return requestedMinimumKey && requestedMinimumKey > todayKey
    ? requestedMinimumKey
    : todayKey;
};

export const clampDateKeyToMinimum = (value, minDate, today = new Date()) => {
  const valueKey = getComparableDateKey(value);
  if (!valueKey) return '';
  const minimumKey = getEffectiveMinimumDateKey(minDate, today);
  return valueKey < minimumKey ? minimumKey : valueKey;
};

export const isEndBeforeStart = (startValue, endValue) => {
  const startKey = getComparableDateKey(startValue);
  const endKey = getComparableDateKey(endValue);
  return Boolean(startKey && endKey && endKey < startKey);
};
